import { render, staticRenderFns } from "./ChannelPart4.vue?vue&type=template&id=bbd76c88&scoped=true&"
import script from "./ChannelPart4.vue?vue&type=script&lang=js&"
export * from "./ChannelPart4.vue?vue&type=script&lang=js&"
import style0 from "./ChannelPart4.vue?vue&type=style&index=0&id=bbd76c88&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd76c88",
  null
  
)

export default component.exports